import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Modal, Button } from "@material-ui/core";

const rand = () => {
    return Math.round(Math.random() * 20) - 10;
};

const getModalStyle = () => {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            position: `absolute`,
            alignItems: `center`,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 2, 2),
        },
        button: {
            margin: theme.spacing(1),
        },
        message: {
            fontSize: `small`,
        },
    })
);

interface Props {
    isOpen: boolean;
    onClickNo: VoidFunction;
    onClickYes: VoidFunction;
    message: string;
}

export const ConfirmModal: React.FC<Props> = (props) => {
    const { isOpen, onClickNo, onClickYes, message } = props;
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);

    const body = (
        <div style={modalStyle} className={classes.paper}>
            <p className={classes.message}>{message}</p>
            <Button variant="contained" color="primary" onClick={onClickNo} className={classes.button}>
                いいえ
            </Button>
            <Button variant="contained" color="primary" onClick={onClickYes} className={classes.button}>
                はい
            </Button>
        </div>
    );

    const onClose = () => {
        // モーダル外をクリックされた場合は、何もしない
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            {body}
        </Modal>
    );
};
